export const i18n = (key: string): string => `${key}`
